import * as React from 'react';
import { styled } from 'styled-components';
import overallResultData from '../../../../../core/bbocResultData';
import BarChunk from './BarChunk';

const BbocProgressBar = ({ score }: Props) => {
	return (
		<Container>
			{overallResultData
				.sort((a, b) => a.min - b.min)
				.map((x) => (
					<BarChunk key={x.title} score={score} bbocResult={x} />
				))}
		</Container>
	);
};

export default BbocProgressBar;

interface Props {
	score: number | null;
}

const Container = styled.div`
	display: flex;
	margin-top: 16px;
`;
